import { Ionicons } from '@expo/vector-icons';
import { T } from '@transifex/react';
import { Badge, BadgeText } from '@vidahealth/vida-ui';
import type { StyleProp, ViewStyle } from 'react-native';

/** "Top coach" pill overlaid on the recommended coach's photo. Private to CoachImage. */
export function TopCoachBadge({ style }: { style?: StyleProp<ViewStyle> }) {
  return (
    <Badge
      className='rounded bg-[rgba(255,255,255,0.85)]'
      pointerEvents='none'
      size='sm'
      style={style}
    >
      <Ionicons name='star' size={12} color='#000000' />
      <BadgeText className='font-body-bold text-black'>
        <T _str='Top coach' />
      </BadgeText>
    </Badge>
  );
}
